// Third-party Library
import { useDispatch } from 'react-redux';
// icons
import { CloseOutlined, DragOutlined } from "@ant-design/icons";
// import ViewModuleIcon from '@mui/icons-material/ViewModule';
// import FitScreenIcon from '@mui/icons-material/FitScreen';
// import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import SignalCellular4BarOutlinedIcon from '@mui/icons-material/SignalCellular4BarOutlined';
import AppsSharpIcon from '@mui/icons-material/AppsSharp';
import SignalWifi4BarOutlinedIcon from '@mui/icons-material/SignalWifi4BarOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GpsFixedOutlinedIcon from '@mui/icons-material/GpsFixedOutlined';
import WindowIcon from '@mui/icons-material/Window';
import SquareIcon from '@mui/icons-material/Square';

// Components
// import SVG from '../../../../../SVG';

// Redux Actions 
import { v3_liveCamera } from "../../../../../../services/redux/actions";

// Styles
import styles from '../../index.module.css'
import { Tooltip } from 'antd';

const {
    unset_selected_live_camera_by_vid_request
} = v3_liveCamera

const CameraActionButtons = ({
    setCamLenHDLR,
    camLen,
    deviceMDVR = {},
    isDragged = false,
    setIsDragged = () => {}
}) => {

    const dispatch = useDispatch()

    return (
        <div className={styles['container-buttons']}>
            <div className={styles['container-button']}>
                <CloseOutlined onClick={() => dispatch(unset_selected_live_camera_by_vid_request())} style={{ marginRight: '10px', color: "#fff" }}/>
                <SquareIcon style={{ color: camLen === 1 ? 'orange' : '#fff' }} onClick={() => setCamLenHDLR(1)} />
                <WindowIcon style={{ color: camLen === 2 ? 'orange' : '#fff' }} onClick={() => setCamLenHDLR(2)}/>
                <AppsSharpIcon style={{ color: camLen === 3 ? 'orange' : '#fff' }} onClick={() => setCamLenHDLR(3)}/>
                <Tooltip
                    placement="top" 
                    title={`Drag and resize. Pull the bottom-down to resize.`}
                >
                    <DragOutlined style={{ color: isDragged ? 'orange' : '#fff', fontSize: '20px' }} onClick={() => setIsDragged(dragged => !dragged)} />
                </Tooltip>
                {/* <FitScreenIcon style={{ color: '#fff' }} />
                <CameraAltOutlinedIcon style={{ color: '#fff' }} />
                <SVG 
                    viewBox="0 0 35 35" 
                    fill="none" 
                    size="30"
                    name={`buzz`}
                /> */}
            </div>

            <div className={styles['container-button']}>
                <LockOutlinedIcon style={{ color: '#fff' }} />
                <Tooltip
                    placement="top" 
                    title={`GPS Updated at ${deviceMDVR.GpsTime}`}
                >
                    <GpsFixedOutlinedIcon style={{ color: deviceMDVR.Lat ? 'orange' : '#fff' }} />
                </Tooltip>
                <SignalCellular4BarOutlinedIcon style={{ color: '#fff' }} />
                <SignalWifi4BarOutlinedIcon style={{ color: '#fff' }} />
            </div>
        </div>
    )
}

export default CameraActionButtons